import {EasingFunctions} from "../../helpers/easing"

export class ErasedLinearInterpolant extends THREE.LinearInterpolant{
  constructor (parameterPositions, sampleValues, sampleSize, resultBuffer, erasingFunction ) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    this.erasingFunction = erasingFunction;
  }

  interpolate_(i1, t0, t, t1){
    const normalized = ( t - t0 ) / ( t1 - t0 );
    const erased = this.erasingFunction(normalized);
    super.interpolate_(i1, t0, ( t1 - t0 ) * erased + t0, t1);
  }
}

export function InterpolantFactoryMethodInOutQuad ( result ) {
  return new ErasedLinearInterpolant( this.times, this.values, this.getValueSize(), result, EasingFunctions.easeInOutQuad);
}